module.exports = __webpack_public_path__ + "img/picture_1.4490064b.png";